import { useMutation } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { useAppDispatch } from 'store';

import { $apiWithoutClient, errorHandler, globalConst } from 'modules/global';

import { setOlympicTestData, startTimer } from '../slices/olympic-test-slice';

export const useOlympicOrder = () => {
  const { push } = useRouter();
  const dispatch = useAppDispatch();

  return useMutation({
    mutationFn: async ({ olympicCourseId }: { olympicCourseId?: number }) => {
      const { data } = await $apiWithoutClient.post('/olympic/olympic-order', {
        olympic_course_id: olympicCourseId
      });

      return data;
    },
    onSuccess: (data, { olympicCourseId }) => {
      dispatch(setOlympicTestData(data));
      dispatch(startTimer());

      push(`${globalConst.pageNames.ONLINE_OLYMPIC}/test/${olympicCourseId}`);
    },
    onError: errorHandler()
  });
};
